export function interopDefault(mod) {
    return mod.default || mod;
}

//# sourceMappingURL=interop-default.js.map